import { render, staticRenderFns } from "./CurriculumVitae.vue?vue&type=template&id=6015d699&"
import script from "./CurriculumVitae.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurriculumVitae.vue"
export default component.exports